// src/app/slice/gallerySlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  photos: [],
  albums: [],
  loading: false,
  error: null,
};

const gallerySlice = createSlice({
  name: "gallery",
  initialState,
  reducers: {
    setPhotos: (state, action) => {
      state.photos = action.payload;
    },
    addPhoto: (state, action) => {
      state.photos.unshift(action.payload);
    },
    deletePhoto: (state, action) => {
      state.photos = state.photos.filter((p) => p.id !== action.payload);
    },
  },
});

export const { setPhotos, addPhoto, deletePhoto } = gallerySlice.actions;
export default gallerySlice.reducer;
